import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { AppCommonsModule } from "src/app/commons/app-commons.module";
import { PlessSharedModule } from "src/app/shared/pless-shared.module";

import { CommonModule } from "@angular/common";
import { WjNavModule } from '@grapecity/wijmo.angular2.nav';
import { WjGridModule } from '@grapecity/wijmo.angular2.grid';
import { WjGridFilterModule } from '@grapecity/wijmo.angular2.grid.filter';
import { KYMW7500Component } from "./kymw7500.component";
import { GetPlanGoodsFeatureService } from "./api-services/get-plan-goods-feature.service";
import { GetGoodsListForCheckPlanNumService } from "./api-services/get-goods-list-for-check-plan-num.service";
import { UpdateCheckPlanNumService } from "./api-services/update-check-plan-num.service";
import { GetBuyerListForCheckPlanNumService } from "./api-services/get-buyer-list-for-check-plan-num.service";
import { GetClassListForCheckPlanNumService } from "./api-services/get-class-list-for-check-plan-num.service";
import { GetCatalogInfoService } from "./api-services/get-catalog-info.service";


@NgModule({
  imports: [
    FormsModule,
    PlessSharedModule,
    AppCommonsModule,
    CommonModule,
    WjNavModule,
    WjGridModule,
    WjGridFilterModule,
  ],
  declarations: [
    KYMW7500Component,
  ],
  providers: [
    GetBuyerListForCheckPlanNumService,
    GetClassListForCheckPlanNumService,
    GetPlanGoodsFeatureService,
    GetGoodsListForCheckPlanNumService,
    UpdateCheckPlanNumService,
    GetCatalogInfoService
  ]
})
export class KYMW7500Module {
}